import { render, staticRenderFns } from "./VPageNavAction.vue?vue&type=template&id=44cb0b53&"
import script from "./VPageNavAction.vue?vue&type=script&lang=js&"
export * from "./VPageNavAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports